import { themeObject } from '../../../../../lib';

export const generalDetailStyles = {
    generalDetailsContainer: {
        width: '510px',
        maxWidth: '800px',
        display: 'inline-block',
    },
    jsonContainer: {
        width: '100%',
        maxHeight: '750px',
    },
    tabsContainer: {
        width: '100%',
        marginBottom: '20px',
    },
    warningContainer: {
        mt: 2.5,
        width: '510px',
    },
    warningMessage: {
        fontFamily: 'Red Hat Text',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '15.88px',
        letter: '0.4px',
        color: themeObject.palette.grayScale[600],
    },
    tabs: {
        height: '36px',
        minHeight: 0,
        textAlign: 'center',
        alignItems: 'center',
    },
};

export const NESTED_TABLE_LEVEL_WARNING = `*The table will only show you two levels deep. If you need more than that, please use the JSON view.`;

export type DetailAccordion = {
    name: string;
    accordionAriaControls: string;
    accordionSumID: string;
    accordionHeader: string;
    data?: any; // could be data, header, verifications, or metadata
};
export const detailAccordions: DetailAccordion[] = [
    {
        name: 'panel1',
        accordionAriaControls: 'panel1-content',
        accordionSumID: 'panel1-header',
        accordionHeader: 'Data',
    },
    {
        name: 'panel2',
        accordionAriaControls: 'panel2-content',
        accordionSumID: 'panel2-header',
        accordionHeader: 'Header',
    },
    {
        name: 'panel3',
        accordionAriaControls: 'panel3-content',
        accordionSumID: 'panel3-header',
        accordionHeader: 'Metadata',
    },
    {
        name: 'panel4',
        accordionAriaControls: 'panel4-content',
        accordionSumID: 'panel4-header',
        accordionHeader: 'Verifications',
    },
];

export const GENERAL_DETAILS_TABS = {
    INFO: 'TABLE',
    JSON: 'JSON',
};

export interface GeneralDetailsSDO {
    data?: any;
    header?: any;
    metadata?: any;
    verifications?: any;
}
